import * as types from '../actionTypes';
import * as eventTypes from '../eventTypes';
import { OFFER_ASSET_CLIENT_UPDATED } from 'features/offer/edit/assets/client/eventTypes';
import {
  OFFER_PARTNER_UPDATED,
  OFFER_ASSOCIATED_PARTNER_DELETED,
  SAVE_ADDED_HIERARCHY_PARTNERS_UPDATED,
  OFFER_PARTNER_RESET
} from 'features/offer/edit/client/form/eventTypes';
import { defaultPartnerId } from 'features/common/selectors';
import { initialPartnerData } from '../selectors';

import initialState from 'reducers/initialState';

export default function reducer(state = initialState.currentOffer.clientData, action) {
  switch (action.type) {
    case types.LOAD_OFFER_PARTNER_SUCCEEDED: {
      const { partnerId } = action.payload;
      const partners = {
        ...state.partners,
        [partnerId]: {
          partnerId,
          isLoaded: true,
          loading: false,
          expanded: true,
          loadedByUniqueId: null
        }
      };

      return {
        ...state,
        partners
      };
    }

    case types.LOAD_OFFER_PARTNER_BY_ID_STARTED: {
      const { partnerId } = action.payload;
      return {
        ...state,
        partners: {
          ...state.partners,
          [partnerId]: {
            ...state.partners[partnerId],
            loading: true,
            isLoaded: false
          }
        }
      };
    }

    case types.LOAD_OFFER_PARTNER_BY_ID_SUCCEEDED: {
      const { partnerId, uniqueId } = action.payload;
      return {
        ...state,
        partners: {
          ...state.partners,
          [partnerId]: {
            ...state.partners[partnerId],
            loadedByUniqueId: uniqueId,
            loading: false,
            isLoaded: true
          }
        }
      };
    }

    case types.LOAD_OFFER_PARTNER_BY_ID_FAILED: {
      const { partnerId } = action.payload;
      return {
        ...state,
        partners: {
          ...state.partners,
          [partnerId]: {
            ...state.partners[partnerId],
            loading: false,
            isLoaded: false
          }
        }
      };
    }

    case types.SAVE_OFFER_PARTNER_STARTED:
      return {
        ...state,
        saving: true
      };

    case types.SAVE_OFFER_PARTNER_FAILED: {
      return {
        ...state,
        saving: false
      };
    }

    case types.SAVE_OFFER_PARTNER_SUCCEEDED: {
      const { partnerId } = action.payload;

      const partners = {
        ...state.partners,
        [partnerId]: {
          partnerId,
          isLoaded: true,
          loading: false,
          expanded: true,
          loadedByUniqueId: null
        }
      };
      delete partners[defaultPartnerId];

      return {
        ...state,
        partners: partners,
        saving: false
      };
    }

    case types.TOGGLE_OFFER_PARTNER_FORM_CARD: {
      const { partnerId } = action.payload;
      const partner = state.partners[partnerId];

      return {
        ...state,
        partners: {
          ...state.partners,
          [partnerId]: {
            ...partner,
            expanded: !partner.expanded
          }
        }
      };
    }

    case OFFER_ASSET_CLIENT_UPDATED: {
      const { clientId } = action.event.eventBody;
      const existingPartnerData = state.partners[clientId] || initialPartnerData;
      return {
        ...state,
        partners: {
          ...state.partners,
          [clientId]: {
            ...existingPartnerData,
            isLoaded: false
          }
        }
      };
    }

    case OFFER_PARTNER_UPDATED: {
      const { partnerId } = action.event.eventBody;

      const existingPartnerData = state.partners[partnerId] || initialPartnerData;
      return {
        ...state,
        partners: {
          ...state.partners,
          [partnerId]: {
            ...existingPartnerData,
            isLoaded: false
          }
        }
      };
    }

    case eventTypes.OFFER_PARTNER_DELETED: {
      const { partnerId } = action.event.eventBody;
      const existingPartnerData = state.partners[partnerId] || initialPartnerData;
      return {
        ...state,
        partners: {
          ...state.partners,
          [partnerId]: {
            ...existingPartnerData,
            isLoaded: false
          }
        }
      };
    }

    case OFFER_ASSOCIATED_PARTNER_DELETED: {
      const partnerId = action.event.eventBody.partnerId;
      const associatedPartners = Object.assign([], state.associatedPartners);
      delete associatedPartners[partnerId];

      return {
        ...state,
        associatedPartners,
        deleting: false
      };
    }

    case OFFER_PARTNER_RESET: {
      const key = action.event.eventBody.partnerId;
      const offerPartners = { ...state.offerPartners };
      const partner = offerPartners[key];
      return {
        ...state,
        deleting: false,
        offerPartners: {
          ...state.offerPartners,
          [key]: {
            ...partner,
            generalData: {
              partnerName: ''
            },
            contactMode: {
              email: '',
              phone: '',
              phoneCountryCode: ''
            },
            addresses: [],
            masterPartnerId: null
          }
        }
      };
    }

    case types.LOAD_CLIENT_BY_CARD_STARTED: {
      const { partnerId } = action.payload;

      return {
        ...state,
        partners: {
          ...state.partners,
          [partnerId]: {
            ...state.partners[partnerId]
          }
        },
        waitingForOCR: true
      };
    }

    case types.LOAD_CLIENT_BY_CARD_SUCCEEDED: {
      const { partnerId, uniqueId } = action.payload;
      return {
        ...state,
        partners: {
          ...state.partners,
          [partnerId]: {
            ...state.partners[partnerId],
            loadedByUniqueId: uniqueId
          }
        },
        waitingForOCR: false
      };
    }

    case types.LOAD_CLIENT_BY_CARD_FAILED: {
      const { partnerId } = action.payload;

      return {
        ...state,
        partners: {
          ...state.partners,
          [partnerId]: {
            ...state.partners[partnerId]
          }
        },
        waitingForOCR: false
      };
    }

    case types.PRINTING_GDPR_STARTED: {
      return {
        ...state,
        printingGdpr: true
      };
    }

    case types.PRINTING_GDPR_SUCCEEDED: {
      return {
        ...state,
        printingGdpr: false
      };
    }

    case types.PRINTING_GDPR_FAILED: {
      return {
        ...state,
        printingGdpr: false
      };
    }

    case types.DELETE_OFFER_ASSOCIATED_PARTNER_STARTED:
      return {
        ...state,
        deleting: true
      };

    case types.DELETE_OFFER_ASSOCIATED_PARTNER_FAILED:
      return {
        ...state,
        deleting: false
      };

    case types.DELETE_OFFER_DOCUMENT_PARTNER_STARTED:
      return {
        ...state,
        deleting: true
      };

    case types.DELETE_OFFER_DOCUMENT_PARTNER_FAILED:
      return {
        ...state,
        deleting: false
      };

    case types.CANCEL_OFFER_CLIENT_CHANGES: {
      const { partnerId } = action.payload;
      const partner = state.partners[partnerId];

      return {
        ...state,
        partners: {
          ...state.partners,
          [partnerId]: {
            ...partner,
            loadedByUniqueId: null
          }
        }
      };
    }
    case SAVE_ADDED_HIERARCHY_PARTNERS_UPDATED: {
      const { addedPartners } = action.event.eventBody;
      var offerPartners = Object.assign({}, state.partners);

      for (let partner of Object.values(addedPartners)) {
        let newPartner = {
          name: partner.partnerName,
          partnerId: partner.partnerId,
          partnerRole: partner.partnerRole,
          partnerRoleCode: partner.partnerRoleCode,
          partnerTypeCode: partner.partnerTypeCode,
          isLoaded: false,
          loading: false,
          expanded: false,
          loadedByUniqueId: null
        };
        if (!offerPartners[partner.partnerId])
          offerPartners = {
            ...offerPartners,
            [partner.partnerId]: newPartner
          };
      }
      return {
        ...state,
        partners: {
          ...offerPartners
        }
      };
    }

    default:
      return state;
  }
}
